import { trackEvent, trackAccountCreatedEvent, trackEventForPartner } from 'src/utils/analytics';
import { clearTrackingSession, trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';
import { getBranch } from 'src/utils/cookie';

const tracking = store => next => action => {
  const result = next(action);
  const state = store.getState();
  switch (action.type) {
    case 'SIGN_UP_SUCCESS':
      // the current session doesn't have a membershipId so in order to update it we need to clear the current one
      clearTrackingSession();
      trackFootfallEvent(footfallEventTypes.SIGNED_UP);
      trackEvent('Account', `Created (${getBranch()})`); // UA
      trackAccountCreatedEvent(`Created (${getBranch()})`); // GA4
      trackEventForPartner(state.context.currentCommunity, 'Account', 'Created');
      break;
    default:
      break;
  }
  return result;
};
export default tracking;
